import React from 'react'
import Container from '@material-ui/core/Container'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Header from './Header'
import GlobalButtons from './GlobalButtons'
import { Helmet  } from 'react-helmet'
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },
    container: {
      flexGrow: 1,
    },
  }),
)

const Layout = (props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Helmet>
        <meta name="description" content="Take2 Prophecy™ 早期鼻咽癌篩查" />
        <title>Take2 Health</title>
      </Helmet>        
      <Header />
      <Container disableGutters className={classes.container} maxWidth="xl">
        {props.children}
      </Container>
      <GlobalButtons />
    </div>
  )
}

export default Layout
